import YAML from 'yaml'
import configs from './PaymentConfigs'
import {store} from '/app/src/store';
import {CompanySelector} from '/app/src/model'

class ConfigHandler {
    constructor() {
        //Initialize, data may be corrupted depending on if redux state has
        //fetched company information.
        this.permissionHierarchy = ['admin', 'modify', 'read']
        this.planID = CompanySelector.getPaymentPlan(store.getState())
        this.allConfigs = YAML.parse(configs)
        this.planConfig = this._craftPlanConfig(this.allConfigs, this.planID)
    }

    checkAccess(service, accessLevel) {
        this._putPlanConfig()
        switch(service) {
            case 'faq':
                return this._checkAccess(['faq', 'self'], accessLevel)
            case 'helpdesk':
                return this._checkAccess(['helpdesk', 'self'], accessLevel)
            case 'automessage':
                return this._checkAccess(['automessage', 'self'], accessLevel)
            case 'file':
                return this._checkAccess(['file', 'self'], accessLevel)
            case 'stats-responseGraph':
                return this._checkAccess(['statistics', 'responseTimeGraph'], accessLevel)
            case 'stats-activityGraph':
                return this._checkAccess(['statistics', 'activityGraph'], accessLevel)
            case 'stats-rating':
                return this._checkAccess(['statistics', 'rating'], accessLevel)
            case 'groupChat':
                return this._checkAccess(['groupChat', 'self'], accessLevel)
            case 'exchange':
                return this._checkAccess(['exchange', 'self'], accessLevel)
            case 'feature-rating':
                return this._checkAccess(['feature', 'rating'], accessLevel)
            default:
                //0 means no access to sought accessLevel.
                return 0
        }
    }

    _putPlanConfig() {
        this.planID = CompanySelector.getPaymentPlan(store.getState())
        this.planConfig = this._craftPlanConfig(this.allConfigs, this.planID)
    }

    _checkAccess(serviceKeys, level) {
        let currentVal = this.planConfig
        for (let i = 0; i < serviceKeys.length; i++) {
            const key = serviceKeys[i]
            currentVal = currentVal[key]
            if (!currentVal) return 0
        }

        const configLevel = Object.keys(currentVal)[0]
        const levelIndex = this.permissionHierarchy.indexOf(level)
        const configLevelIndex = this.permissionHierarchy.indexOf(configLevel)
        if (levelIndex < configLevelIndex) return 0
        else if (levelIndex > configLevelIndex) return 'unlimited'
        else return Object.values(currentVal)[0]
    }

    _craftPlanConfig(configs, planID) {
        const planConfig = {}
        Object.keys(configs).forEach((service) => {
            const specs = configs[service][planID]
            if (specs) {
                planConfig[service] = specs
            }
        })
        return planConfig
    }
}

export default new ConfigHandler()



// WEBPACK FOOTER //
// ./src/config/PaymentConfigHandler.js